import React from 'react'

export const IconDepartment: React.FC = () => {
  return (
    <svg width="33" height="35" viewBox="0 0 33 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M28.1 9.68421H23.75V6.84211C23.75 5.27468 22.4494 4 20.85 4H12.15C10.5507 4 9.25 5.27468 9.25 6.84211V9.68421H4.9C3.30065 9.68421 2 10.9589 2 12.5263V28.1579C2 29.7253 3.30065 31 4.9 31H28.1C29.6994 31 31 29.7253 31 28.1579V12.5263C31 10.9589 29.6994 9.68421 28.1 9.68421ZM20.85 6.84211V9.68421H12.15V6.84211H20.85ZM10.7 12.5263H28.1V16.7895H4.9V12.5263H10.7ZM4.9 28.1579V19.6316H13.6V22.4737H19.4V19.6316H28.1L28.1015 28.1579H4.9Z" />
    </svg>
  )
}
